export enum RoutePath {
  LandingPage = '/',
  LandlordPage = '/fastighetsagare',
  LandlordContactPage = '/fastighetsagare/contact-form',
  LandlordOrderPage = '/fastighetsagare/bestall',
  LandlordOrderOrganisation = '/fastighetsagare/bestall/organisation',
  LandlordOrderServices = '/fastighetsagare/bestall/tjanster',
  LandlordOrderProperty = '/fastighetsagare/bestall/fastighets',
  LandlordOrderContact = '/fastighetsagare/bestall/kontakt',
  LandlordOrderSummary = '/fastighetsagare/bestall/sammanfat',
  OrderPage = '/bestall',
  SupportPage = '/kundtjanst',
  ContactFormPage = '/contact-form',
  WhereDoYouLivePage = '/adress',
  ServiceProviders = '/tjanster',
  SimplePage = '/pages',
  StatusPage = '/status',
  OrderFlowPage = '/order',
  OrderDetailsPage = '/order-details',
  Access = '/access',
  NoticeOfInterestGenericPage = '/intresseanmalan',
  NoticeOfInterestUpsellPage = '/intresseanmalan-upsell',
  NoticeOfInterestAlreadyRegisteredPage = '/intresseanmalan-redan-angiven',
  NoticeOfInterestAreaPage = '/intresseanmalan-area',
  OrderSuccessPage = '/thank-you',
  CampaignExpiredPage = '/campaign-expired',
  AccessibilityReportFormPage = '/fragor-om-tillgänglighet'
}

export enum RouteName {
  LandingPage = 'LandingPage',
  LandlordPage = 'LandlordPage',
  LandlordContactPage = 'LandlordContactPage',
  LandlordOrderPage = 'LandlordOrderPage',
  LandlordOrderOrganisation = 'LandlordOrderOrganisation',
  LandlordOrderServices = 'LandlordOrderServices',
  LandlordOrderProperty = 'LandlordOrderProperty',
  LandlordOrderContact = 'LandlordOrderContact',
  LandlordOrderSummary = 'LandlordOrderSummary',
  OrderPage = 'OrderPage',
  SupportPage = 'SupportPage',
  SupportPageDefault = 'SupportPageDefault',
  ContactFormPage = 'ContactFormPage',
  WhereDoYouLivePage = 'WhereDoYouLivePage',
  ServiceProviders = 'ServiceProvidersPage',
  SimplePage = 'SimplePage',
  StatusPage = 'StatusPage',
  OrderFlowPage = 'OrderFlowPage',
  OrderDetailsPage = 'OrderDetailsPage',
  Access = 'Access',
  NoticeOfInterestGenericPage = 'NoticeOfInterestGenericPage',
  NoticeOfInterestAlreadyRegisteredPage = 'NoticeOfInterestAlreadyRegisteredPage',
  NoticeOfInterestAreaPage = 'NoticeOfInterestAreaPage',
  OrderSuccessPage = 'OrderSuccessPage',
  CampaignExpiredPage = 'CampaignExpiredPage',
  AccessibilityReportFormPage = 'AccessibilityReportFormPage'
}
